<template>
  <div class="main">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item,index) in list" :key="index">
        <el-image :src="item.img"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div>
		<div class="FFFback jjfa">
			<div class="qyhxys" style="height:900px;">
				<div class="content">
					<h1 class="jjfa-title">智慧物联解决方案</h1>
					<div class="line"></div>
					<div class="jjfa-text">
						提供多终端协同、软硬件相组合的一体化解决方案，通过智能化管控来提升效率、安全性和用户体验
					</div>
				</div>
				<div class="btn-content">
					<div class="jjfa-btn" :class="{'jjfaColor':jjfaIndex===index}" v-for="(item,index) in jjfaBtns" :key="index" @click="handleBtns(index)">
						{{item.name}}
					</div>
				</div>
				<div class="jjfa-imgs">
					<el-carousel ref="carousel" height="100%" :initial-index="jjfaIndex" indicator-position="none" :autoplay="false" :loop="false" arrow="never">
						<el-carousel-item v-for="(item,index) in jjfaList" :key="index">
							<el-image :src="item.img"></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="carousel-title" v-show="jjfaIndex===0">
					配合船载AIS设备终端应用场景接入船舶轨迹及电子航道图数据服务，实现物流运输可跟踪、可追溯、可分析，构建包括智能视频行为采集识别分析、货运全流程智慧管理等在内的基础服务，提供智能物联网接口服务，打造长江流域易用的物流服务工具。
				</div>
				<div class="carousel-title" v-show="jjfaIndex===1">
					集成了棚内环境与墒情检测杆（监测土壤温湿度、PH值、土壤氮磷钾含量及水质等）以及户外监测气象杆（气候条件、降雨量等），一旦监测值超出预设警戒范围，会立即触发自动告警提醒。此外，通过先进的AI算法，系统能有效识别外来人员闯入，保障农田安全。
				</div>
				<div class="carousel-title" v-show="jjfaIndex===2">
					通过实时视频监控+AI算法技术，实现了对管理现场的全面、即时洞察。同时，系统还配备了智能电表监测功能，为物业管理者提供了详尽、准确的能耗数据，有助于实现能源的合理分配与高效利用，进一步推动物业管理的智能化与绿色化进程。
				</div>
			</div>
		</div>
		<div class="FFFback lsks">
			<div class="qyhxys" style="height:956px;">
				<div class="content">
					<h1 class="jjfa-title lsks-title">绿色矿山智能化综合管控平台</h1>
					<div class="line"></div>
					<div class="jjfa-text lsks-text">
						实现矿山生产、安全、环境、装备管理等全流程可视化的综合性系统
					</div>
				</div>
				<img class="lsks-imgs" src="../../assets/image/index/lsks.png" />
			</div>
		</div>
		<div class="FFFback shxt">
			<div class="qyhxys" style="height:880px">
				<div class="content">
					<h1 class="jjfa-title shxt-title">越野拉力赛事CRS系统</h1>
					<div class="line"></div>
					<div class="jjfa-text shxt-text">
						一款专为越野拉力赛事打造的产品，提供全面的赛事控制与服务支持
					</div>
				</div>
				<img class="shxt-imgs" src="../../assets/image/index/sh_bck.png" />
			</div>
		</div>
		<div class="FFFback xw">
			<div class="qyhxys" style="height:760px;">
				<div class="content">
					<h1 class="jjfa-title shxt-title">新闻资讯</h1>
					<div class="line"></div>
					<div class="jjfa-text shxt-text">
						不要错过我们的最新动态，第一时间获取前沿资讯、公司发展动态
					</div>
				</div>
				<div class="news-ul">
					<div class="news-li" v-for="(item,index) in newsList" :key="index" @click="toDetail(item.id)">
						<img :src="item.pic"/>
						<h6>{{item.title}}</h6>
						<p class="news-desc">{{item.illustrate}}</p>
						<div class="newsDate">{{ $moment(item.createTime).format('YYYY-MM-DD') }}</div>
					</div>
				</div>
				<div class="seeMore" @click="seeMore">查看更多 > </div>
			</div>
		</div>
		<div class="yjback">
			<div class="qyhxys guanyuyujiang">
				<div>
					<h1>关于禹江</h1>
					<div>
						<div class="port-7 effect-3">
							<div class="image-box">
								<img src="../../assets/image/index/pexels-jeshootscom-442580.png">
							</div>
							<div class="text-desc">
								<h3>公司介绍</h3>
								<p>智慧助力航运</p>
								<p>合作多联共赢</p>
								<div class="moreA" @click="toModel('/introduce','4')">了解详情</div>
							</div>
						</div>
						<div class="port-7 effect-3">
							<div class="image-box">
								<img src="../../assets/image/index/IMG_4961.png">
							</div>
							<div class="text-desc">
								<h3>加入我们</h3>
								<p>创新、实践、奉献、共赢</p>
								<p>以责任为基、以市场为需</p>
								<div class="moreA" @click="toModel('/joinus','4')">了解详情</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="FFFback hzhb">
			<div class="qyhxys" style="height:700px">
				<div class="content">
					<h1 class="jjfa-title shxt-title">合作伙伴</h1>
					<img src="../../assets/image/index/hzhb.png" />
				</div>
			</div>
		</div>
    </div>
  </div>
</template>
<script>
import { owJournalism } from "@/api/api";
export default {
  name: "index",
  data() {
    return {
      list: [
        {
          img: require("@/assets/image/index/001.png")
          // name: "一江通",
          // span: "智慧物流服务平台",
          // btn: require("@/assets/image/index/btn.png")
        },
        {
          img: require("@/assets/image/index/002.png")
          // title: "智慧助力航运 合作多联共赢"
        },
        {
          img: require("@/assets/image/index/003.png")
          // title: "以责任为基 以市场为需"
        },
        {
          img: require("@/assets/image/index/004.png")
        }
      ],
      isLogo: false,
      newsList: [],
      queryParams: {
        currentPage: 1,
        pageSize: 3
      },
			jjfaIndex: 0,
			jjfaBtns: [
				{name:"智慧航运"},{name:"智慧农业"},{name:"智慧物业"}
			],
			initialIndex: 1,
			jjfaList: [
				{
          img: require("@/assets/image/index/jjfa_hy.png"),
        },
				{
          img: require("@/assets/image/index/jjfa_ny.png")
        },
				{
          img: require("@/assets/image/index/jjfa_wy.png")
        }
			],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
		handleBtns(index){
			this.jjfaIndex = index;
			 this.$refs.carousel.setActiveItem(index);
		},
    getList() {
      let params = this.queryParams;
      owJournalism(params).then(res => {
        if (res.success == true) {
          this.newsList = res.data.records;
        }
      });
    },
    toModel(path, activeIndex) {
      this.$router.push({
        path: path,
        query: { activeIndex: activeIndex }
      });
    },
    seeMore(event) {
      event.stopPropagation();
      this.$router.push({
        path: "/industryNews",
        query: { activeIndex: "2" }
      });
    },
    toDetail(id) {
      this.$router.push({
        path: "/detail",
        query: { id: id, activeIndex: "2" }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.main {
  display: block;
  flex: 1;
}
::v-deep .el-carousel__container {
  height: 34.75rem;
  width: 100%;
  h1 {
    position: absolute;
    top: 12%;
    width: 100%;
    text-align: center;
    color: #ffffff;
    font-size: 3.2rem;
    letter-spacing: 1rem;
    z-index: 9999;
  }
  h2 {
    position: absolute;
    top: 20%;
    left: 20%;
    color: #ffffff;
    font-size: 3.5rem;
    letter-spacing: 1rem;
    z-index: 9999;
    animation: dragTop 0.7s ease-in-out both;
  }
  h3 {
    position: absolute;
    top: 45%;
    left: 20%;
    color: #ffffff;
    font-size: 3.125rem;
    letter-spacing: 1rem;
    z-index: 9999;
  }
  .el-image {
    height: 100%;
    width: 100%;
  }
}
::v-deep .el-carousel__indicators--outside {
  bottom: 0.6rem;
  position: absolute;
}
.hyzx {
  .el-carousel--vertical {
    max-height: 400px;
  }
}
</style>
